import React from 'react';
import InfiniteScrollCards from '@/components/cards/InfiniteScrollCards';
import CollectionDatasetCardItems from './CollectionDatasetCardItems';

const CollectionDatasetCards = ({
  canCreate,
  category,
  code,
  handleScroll,
  items,
  itemsPreRow,
  readErrors,
  readStatus,
  showAddDataset,
}) => (
  <InfiniteScrollCards
    canCreate={canCreate}
    className="aridhia-collection-dataset-cards"
    entity="collection.datasets"
    handleScroll={handleScroll}
    icon="table"
    items={items}
    itemsPerRow={itemsPreRow}
    loading
    onClick={() => showAddDataset(category, code)}
    readErrors={readErrors}
    readStatus={[readStatus]}
  >
    <CollectionDatasetCardItems category={category} code={code} items={items} />
  </InfiniteScrollCards>
);

export default CollectionDatasetCards;
